import type { CSSProperties } from "react";

export const cardBodyStyle: CSSProperties = {
  display: "flex", flexWrap: "wrap", gap: 8, padding: "8px 10px",
};

export const chartBoxStyle: CSSProperties = {
  background: "var(--semi-color-bg-1)",
  borderRadius: 6,
  padding: 8,
  flex: "1 1 280px",
  minWidth: 280,
  transition: "box-shadow .18s ease",
};

export const chartTitleStyle: CSSProperties = {
  fontSize: 13, fontWeight: 600, color: "var(--semi-color-text-1)",
  marginBottom: 4, display: "block",
};

export const kpiBoxStyle: CSSProperties = {
  display: "flex", flexWrap: "wrap", gap: 6,
};

export const kpiItemStyle: CSSProperties = {
  flex: "1 1 84px", minWidth: 84, padding: "6px 10px",
  borderRadius: 4, background: "var(--semi-color-bg-1)",
  borderLeft: "3px solid var(--semi-color-primary)",
};

export const dashboardHeaderStyle: CSSProperties = {
  display: "flex", alignItems: "center", gap: 8,
  padding: "8px 4px", marginBottom: 4,
};

export const dashboardHeaderTitleStyle: CSSProperties = {
  fontSize: 15, fontWeight: 700, color: "var(--semi-color-text-0)",
  flex: "0 0 auto",
};

export const dashboardHeaderExtraStyle: CSSProperties = {
  marginLeft: "auto", display: "flex", gap: 6, alignItems: "center",
  color: "var(--semi-color-text-2)", fontSize: 12,
};

export const dashboardLoadingMaskStyle: CSSProperties = {
  position: "fixed", inset: 0,
  background: "rgba(var(--semi-color-white-rgb, 255,255,255), 0.55)",
  backdropFilter: "blur(2px)",
  display: "flex", alignItems: "center", justifyContent: "center",
  zIndex: 1000,
};

export const QUALITY_COLOR_MAP: Record<string, string> = {
  excellent: "#00B42A",
  good: "#0093FF",
  normal: "#FF7D00",
  poor: "#F53F3F",
  noScore: "#86909C",
  no_score: "#86909C",
};

export const INTENTION_COLOR_MAP: Record<string, string> = {
  A: "#00B42A",
  B: "#23C343",
  C: "#FF7D00",
  D: "#FF9A2E",
  E: "#F53F3F",
  pending: "#86909C",
};

export const STAR_COLOR_MAP: Record<string, string> = {
  "5": "#F7BA1E",
  "4": "#23C343",
  "3": "#0093FF",
  "2": "#FF7D00",
  "1": "#F53F3F",
};

export const PALETTE_QUALITY = ["#00B42A", "#23C343", "#FF7D00", "#F53F3F", "#86909C"];
export const PALETTE_INTENTION = ["#00B42A", "#23C343", "#FFD500", "#FF7D00", "#F53F3F", "#86909C"];
export const PALETTE_STAR = ["#F7BA1E", "#23C343", "#0093FF", "#FF7D00", "#F53F3F"];
export const PALETTE_GENERAL = ["#0093FF", "#23C343", "#FF7D00", "#F7BA1E", "#F53F3F", "#86909C"];
